import { useCallback, useEffect, useState } from "react"

export type Appearance = "light" | "dark"

const applyTheme = (appearance: Appearance) => {
  const isDark = appearance === "dark"
  if (isDark) {
    document.documentElement.classList.add("dark")
  } else {
    document.documentElement.classList.remove("dark")
  }
  document.documentElement.style.background = isDark ? "#121212" : "#ecf4ff"
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", isDark ? "#121212" : "#ecf4ff")
}

export function initializeTheme() {
  const storedAppearance = localStorage.getItem(
    "appearance",
  ) as Appearance | null
  const appearance = storedAppearance ?? "dark"
  applyTheme(appearance)
}

export function useAppearance() {
  const [appearance, setAppearance] = useState<Appearance>(() => {
    const stored = localStorage.getItem("appearance") as Appearance | null
    return stored ?? "dark"
  })

  const updateAppearance = useCallback((mode: Appearance) => {
    setAppearance(mode)
    localStorage.setItem("appearance", mode)
    applyTheme(mode)
  }, [])

  useEffect(() => {
    const stored = localStorage.getItem("appearance") as Appearance | null
    if (stored && stored !== appearance) {
      updateAppearance(stored)
    }
  }, [])

  return { appearance, updateAppearance } as const
}
